import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si recién empiezo y no tengo experiencia?',
    a: 'Sí. El sistema va de cero a negocio armado. No necesitás experiencia previa en emprendimientos ni en gastronomía.'
  }, {
    q: '¿Sirve si ya vendo pero no me alcanza la plata?',
    a: 'Exactamente para eso fue creado. El Tomo 3 (Costos y Precios Blindados) y el Bono 6 (Plantillas de Control) son los que más impacto inmediato generan.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Inmediatamente después del pago recibís acceso a los 12 archivos del sistema.'
  }, {
    q: '¿Qué lo diferencia de un curso de cocina o repostería?',
    a: 'Todo. Esto no enseña a cocinar. Enseña a armar un negocio rentable de desayunos sorpresa: costos, ventas, contenido, logística y escala.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. El 100% del dinero de vuelta si no es lo que esperabas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-dark-card/30 pt-[25px] pb-[25px]" data-id="element-133">
      <div className="max-w-3xl mx-auto" data-id="element-134">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-135">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-136">
          {faqs.map((faq, i) => <div key={i} className="bg-dark border border-dark-border rounded-xl overflow-hidden" data-id="element-137">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-138">
                <span className="font-bold text-lg" data-id="element-139">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-140" />
              </button>
              <AnimatePresence data-id="element-141">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-142">
                    <div className="p-6 pt-0 text-gray-400 border-t border-dark-border/50 mt-2" data-id="element-143">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}